import { render } from "./DefaultPrintPage.vue?vue&type=template&id=228f0649"
import script from "./DefaultPrintPage.vue?vue&type=script&lang=js"
export * from "./DefaultPrintPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__